import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { interaction___menu, interaction___close } from '@lsg/icons';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { texts } from '../../utils/Localization.js';
import { fComp } from '../../utils/React.js';
import { DrawerWrapper } from '../Drawer/DrawerWrapper.js';
import { IconLinkWrapper } from '../IconLink/IconLinkWrapper.js';
import { IconLinkGroupWrapper } from '../IconLinkGroup/IconLinkGroupWrapper.js';
import { LogoPresentation } from '../Logo/LogoPresentation.js';
import { NavigationBarPresentation } from '../NavigationBar/NavigationBarPresentation.js';
import { NavigationBlockWrapper } from '../NavigationBlock/NavigationBlockWrapper.js';
import { SectionPresentation } from '../Section/SectionPresentation.js';
import { ThemePresentation } from '../Theme/ThemePresentation.js';
import { HeaderContainerWrapper } from '../_HeaderContainer/HeaderContainerWrapper.js';
import { hostClass } from './SimpleHeader.styles.js';

var defaultProps = {};
var SimpleHeaderPresentation = fComp(function (props) {
  var _cleanupClassObject;
  var id = props.id,
    className = props.className,
    noMargin = props.noMargin,
    isStencilHost = props.isStencilHost,
    activeRef = props.activeRef,
    activeElement = props.activeElement,
    isSticky = props.isSticky,
    isMobile = props.isMobile,
    logoSrcMobile = props.logoSrcMobile,
    logoSrcDesktop = props.logoSrcDesktop,
    logoHref = props.logoHref,
    logoAlt = props.logoAlt,
    logoHtmlAttrs = props.logoHtmlAttrs,
    logoDisabled = props.logoDisabled,
    logoActionAs = props.logoActionAs,
    logoActionProps = props.logoActionProps,
    onLogoClick = props.onLogoClick,
    segmentLabel = props.segmentLabel,
    navigationTree = props.navigationTree,
    navigationActionAs = props.navigationActionAs,
    value = props.value,
    _onChange = props.onChange,
    name = props.name,
    iconLinksInteraction = props.iconLinksInteraction,
    onOpenChange = props.onOpenChange,
    onForceMobileChange = props.onForceMobileChange,
    open = props.open;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement(HeaderContainerWrapper, {
    width: "page",
    theme: "dark",
    activeElement: activeElement,
    isFullUnderline: false,
    isSticky: isSticky,
    isMobile: isMobile,
    onForceMobileChange: onForceMobileChange,
    logo: /*#__PURE__*/React.createElement(LogoPresentation, {
      variant: isMobile ? "mobile" : "horizontal",
      disabled: logoDisabled,
      href: logoHref,
      onClick: onLogoClick,
      actionAs: logoActionAs,
      actionProps: logoActionProps,
      alt: logoAlt,
      srcCustom: isMobile ? logoSrcMobile : logoSrcDesktop,
      htmlAttrs: Object.assign({
        "aria-label": texts.lsg.component.Logo.actionHome
      }, logoHtmlAttrs),
      fitToBox: true
    }),
    segmentLabel: segmentLabel,
    topRight: /*#__PURE__*/React.createElement(React.Fragment, null, !isMobile && /*#__PURE__*/React.createElement(NavigationBarPresentation, {
      className: "".concat(hostClass, "-navigation"),
      navigationTree: navigationTree,
      navigationActionAs: navigationActionAs,
      value: value,
      activeRef: activeRef,
      onChange: function onChange(v, e) {
        return _onChange(v, name, e);
      }
    }), (iconLinksInteraction || isMobile) && /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
      noMargin: true,
      direction: "collapse-xs"
    }, iconLinksInteraction, isMobile && navigationTree && navigationTree.length > 0 && /*#__PURE__*/React.createElement(IconLinkWrapper, {
      icon: interaction___menu,
      look: "no-text",
      onClick: function onClick() {
        return onOpenChange(true);
      }
    }, "Open Menu")))
  }), /*#__PURE__*/React.createElement(ThemePresentation, {
    componentContext: true,
    componentName: "header"
  }, /*#__PURE__*/React.createElement(DrawerWrapper, {
    open: isMobile && open,
    layout: "side-menu-right",
    onBackdropClick: function onBackdropClick() {
      return onOpenChange(undefined);
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "sticky",
      top: 0,
      zIndex: 4
    }
  }, /*#__PURE__*/React.createElement(HeaderContainerWrapper, {
    width: "layer",
    theme: "elevated",
    isMobile: isMobile,
    topRight: /*#__PURE__*/React.createElement(IconLinkGroupWrapper, {
      noMargin: true
    }, /*#__PURE__*/React.createElement(IconLinkWrapper, {
      icon: interaction___close,
      onClick: function onClick() {
        return onOpenChange(undefined);
      },
      look: "no-text"
    }, "Schliessen"))
  })), /*#__PURE__*/React.createElement(SectionPresentation, null, /*#__PURE__*/React.createElement(NavigationBlockWrapper, {
    navigationTree: navigationTree,
    navigationActionAs: navigationActionAs,
    startLevel: "page",
    onChange: function onChange(v, e) {
      return _onChange(v, name, e);
    },
    value: value
  })))));
}, defaultProps);
SimpleHeaderPresentation.displayName = "SimpleHeaderPresentation";

export { SimpleHeaderPresentation, defaultProps };
